import { Form } from 'factorial-form'

class Filters extends Form {
  constructor(values: object) {
    super(values, {
      sortDirection: 'string', // it contains the direction of sort
      sortAttribute: 'string', // it contains the attribute of sort
      filterBy: 'any', // Since this can contain team (number) or activity (string)
    })
  }
}

export default Filters
